import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import Skeleton from "react-loading-skeleton";
import { getTotalNumOfAnalystics } from "../../../../redux/action/analystics";

function TotalAuctionStatus() {
  const dispatch = useDispatch();
  const isDastop = useMediaQuery({ query: "(max-width: 1420px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 600px)" });

  const { analystics, loadings } = useSelector(
    (state) => state?.analysticsData
  );
  useEffect(() => {
    dispatch(getTotalNumOfAnalystics());
  }, [dispatch]);



  return (
    <div
      className={`flex ${isTablet ? "column " : !isDastop && "column"} `}
      style={{ gap: "10px", minWidth: "310px" }}
    >
      <div
        className="cover flex white p-1 valign-wrapper gap-1 "
        style={{
          boxShadow: "rgba(0, 0, 0, 0.25) 1.5px 2.95px 3.6px",
        }}
      >
        <img src="images/upcomingAuction.png" alt="upcomingAuctions" width={60} />

        <div>
          <h4 className=" cercle-purple-text">
            Upcoming Auction
          </h4>
          <h1 style={{ margin: "7px" }}>
            {loadings ? <Skeleton width={100} /> : analystics?.upcomingAuctions}
          </h1>
        </div>
      </div>
      <div
        className="cover flex white p-1 valign-wrapper gap-1 "
        style={{
          boxShadow: "rgba(0, 0, 0, 0.25) 1.5px 2.95px 3.6px",
        }}
      >
        <img src="images/completedAuction.png" alt="complete" width={60} />
        <div>
          <h4 className="font-cercular-bold cercle-purple-text">
            Completed Auction
          </h4>

          <h1 style={{ margin: "7px" }}>
            {loadings ? (
              <Skeleton width={100} />
            ) : (
              analystics?.completedAuctions
            )}

          </h1>
        </div>
      </div>
    </div>
  );
}

export default TotalAuctionStatus;
